import Cookies from "universal-cookie";

export const cookiesMiddleware = (store) => (next) => (action) => {
  const cookies = new Cookies(null, { path: "/" });
  if (action.type === "@EE/SET_COOKIE") {
    cookies.set(action.key, action.value);
  } else if (action.type === "@EE/EXPIRE_COOKIE") {
    cookies.remove(action.key);
  }

  return next(action);
};
